import Loadable from 'react-loadable';
import Loading from '../../../../components/util/loading/Loading';

const Home = Loadable({
    loader: () => import('../index'),
    loading: Loading,
});

export default Home;